import type { Axis2 } from "../../types/input";

/**
 * Position du pointeur en coordonnées normalisées [-1, 1], origine au centre,
 * `y` vers le haut. Écrit dans `out` et renvoie faux si la cible n'a pas encore
 * de taille — au premier rendu, elle peut ne pas en avoir.
 */
export const normalizePointer = (
  event: { clientX: number; clientY: number },
  target: HTMLElement,
  out: Axis2,
): boolean => {
  const rect = target.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return false;
  out.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
  out.y = -(((event.clientY - rect.top) / rect.height) * 2 - 1);
  return true;
};
